import React from "react";
import { Info } from "lucide-react";

// Audit G01/G02. The safeguard has to sit where the content is read, not only in
// the website terms a visitor never opens.
export const AdviceNotice = ({ dark = false, className = "" }) => (
  <p
    data-testid="advice-notice"
    className={`flex items-start gap-2 text-xs leading-relaxed ${dark ? "text-slate-400" : "text-slate-500"} ${className}`}
  >
    <Info size={14} className="shrink-0 mt-0.5 text-orange" />
    <span>
      These answers provide general information, not advice tailored to your circumstances. Rules can change and
      exceptions may apply — speak to the CASS team before making a tax, accounting or financial decision.
    </span>
  </p>
);

// Shown before anything is typed — beside the search box and at the chatbot
// entry point — because searches and anonymous page counts are recorded (G02).
export const SearchPrivacyNote = ({ className = "", dark = false }) => (
  <p
    data-testid="search-privacy-note"
    className={`text-xs leading-relaxed ${dark ? "text-slate-400" : "text-slate-500"} ${className}`}
  >
    Search terms and chatbot messages are recorded to help answer questions and improve Ask Cassie, along with an
    anonymous count of the pages and answers opened here — no cookies and nothing that identifies you. Please don't
    enter passwords, bank details, National Insurance numbers, tax reference numbers or confidential information about
    another person or business. See our{" "}
    <a href="/privacy-policy" className="underline hover:text-orange">Privacy Policy</a> for details.
  </p>
);

export default AdviceNotice;
